import { defineMessages } from 'react-intl'

const scope = `procurify.hooks.useSavedFilterManager`

export default defineMessages({
  notificationSuccessTitle: {
    id: `${scope}.notificationSuccessTitle`,
    defaultMessage: 'Success',
  },
  notificationSaveSuccessMessage: {
    id: `${scope}.notificationSavedSuccessMessage`,
    defaultMessage: 'Filter saved successfully',
  },
})
